<div [brManageMenuButton]="menu"></div>
<div [class.top-padding]="isNavFixed"><span></span></div>
<div class="header-wrapper" [class.fixed]="isNavFixed" [ngClass]="pageTitleVisDemo">
  <div class="main-header">
    <mflooring-layout-wrapper
      [content]="layoutContainerProp.content"
      [presentation]="layoutContainerProp.presentation"
      >
      <div class="header-container">
        @if (menu && menuItems?.length) {
          @if (!isMobile) {
            <mflooring-main-desktop
              [position]="isNavFixed"
              [menuItems]="menuItems"
              [page]="page"
              [mainHeaderData]="mainHeaderData"
            ></mflooring-main-desktop>
          }
          @if (!!isMobile) {
            <mflooring-main-mobile
              [position]="isNavFixed"
              [menuItems]="menuItems"
              [page]="page"
              [mainHeaderData]="mainHeaderData"
            ></mflooring-main-mobile>
          }
        }
      </div>
    </mflooring-layout-wrapper>
  </div>
  <mflooring-message-bar></mflooring-message-bar>
</div>
